import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { checkPermission } from 'utils/checkPermission';
import ButtonActive from 'utils/buttons/ButtonActive';
import ButtonDelete from 'utils/buttons/ButtonDelete';
import ButtonEdit from 'utils/buttons/ButtonEdit';
import ButtonFinish from 'utils/buttons/ButtonFinish';
import ButtonPause from 'utils/buttons/ButtonPause';
import ButtonView from 'utils/buttons/ButtonView';
import PropTypes from 'prop-types';
import { Dropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import ButtonShareProperty from 'utils/buttons/ButtonShareProperty';
import ButtonShareSocial from 'utils/buttons/ButtonShareSocial';
import ButtonCopyProperty from 'utils/buttons/ButtonCopyProperty';
import {
  changeStatusProject,
  copyProject,
  deleteProject
} from 'redux/projectsSlice';
import DeleteModal from '../modals/DeleteModal';
import PauseModal from '../modals/PauseModal';
import FinishModal from '../modals/FinishModal';
import ActiveModal from '../modals/ActiveModal';
import ShareModal from '../modals/ShareModal';
import { TitleGenerator } from 'utils/TitleGenerator';
import SendModal from 'sites/admin/inmobiliario/gestionarPropiedades/modals/SendModal';
import ButtonPreview from 'utils/buttons/ButtonPreview';

export const ProjectActions = ({
  project,
  userLogged,
  setCheckChanges,
  onlyView
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  //Modales
  const [deleteModal, setDeleteModal] = useState(false);
  const [pauseModal, setPauseModal] = useState(false);
  const [finishModal, setFinishModal] = useState(false);
  const [activeModal, setActiveModal] = useState(false);
  const [shareModal, setShareModal] = useState(false);
  const [sendModal, setSendModal] = useState(false);

  const handleStatus = async data => {
    let status = data.status;
    let id = data.id;
    if (status === 'deleted') {
      await dispatch(deleteProject(id));
    } else {
      await dispatch(changeStatusProject(id, status));
    }

    setCheckChanges(true);
  };

  const handleCopyButton = propId => {
    const response = dispatch(copyProject(propId));

    response.then(res => {
      res !== 400 && navigate(`/emprendimientos/editar/${res}`);
    });
  };

  return (
    <>
      <span className="d-flex gap-2">
        {!onlyView && (
          <ButtonEdit
            data={project._id}
            funcion={id => navigate(`/emprendimientos/editar/${id}`)}
            key={`edit-${project._id}`}
            disabled={
              !(
                project.status !== 'finished' &&
                checkPermission(
                  'Edit properties',
                  userLogged,
                  project.branch_office
                )
              )
            }
          />
        )}

        {/* modal sendModald button */}
        <ButtonShareSocial
          disabled={!(project.status === 'published')}
          className="w-100"
          funcion={() => setSendModal(true)}
          data={project}
          justify="start"
        />

        <ButtonView
          key={`view-${project._id}`}
          link={`${process.env.REACT_APP_CLIENT_DETAIL_PROJECT}${
            project._id
          }/${TitleGenerator(project.title)}`}
          disabled={!(project.status === 'published')}
        />

        {!onlyView && (
          <Dropdown className="font-sans-serif btn-reveal-trigger">
            <Dropdown.Toggle
              variant="link"
              className="text-600 btn-reveal p-0 px-1 m-0 fs-1"
            >
              <FontAwesomeIcon icon="ellipsis-v" />
            </Dropdown.Toggle>

            <Dropdown.Menu className="bg-white border p-1">
              <Dropdown.Item className="p-1">
                <ButtonEdit
                  data={project._id}
                  funcion={id => navigate(`/emprendimientos/editar/${id}`)}
                  key={`edit-${project._id}`}
                  disabled={
                    !checkPermission(
                      'Edit properties',
                      userLogged,
                      project.branch_office
                    )
                  }
                  text="Editar"
                  className="w-100"
                  justify="start"
                />
              </Dropdown.Item>

              <Dropdown.Item
                to={`${process.env.REACT_APP_CLIENT_DETAIL_PROJECT}${
                  project._id
                }/${TitleGenerator(project.title)}`}
                target="_blank"
                as={Link}
                className="p-1"
              >
                <ButtonView
                  key={`view-${project._id}`}
                  disabled={!(project.status === 'published')}
                  text="Ver"
                  className="w-100"
                  justify="start"
                />
              </Dropdown.Item>

              {['pending', 'paused'].includes(project.status) ? (
                <Dropdown.Item
                  to={`${
                    process.env.REACT_APP_CLIENT
                  }/vista-previa/emprendimiento/${project._id}/${TitleGenerator(
                    project.title
                  )}`}
                  target="_blank"
                  as={Link}
                  className="p-1"
                >
                  <ButtonPreview
                    key={`view-${project._id}`}
                    text="Vista previa"
                    className="w-100"
                    justify="start"
                  />
                </Dropdown.Item>
              ) : (
                <Dropdown.Item className="p-1">
                  <ButtonPreview
                    key={`view-${project._id}`}
                    disabled={true}
                    text="Vista previa"
                    className="w-100"
                    justify="start"
                  />
                </Dropdown.Item>
              )}

              <Dropdown.Item className="p-1">
                <ButtonCopyProperty
                  key={`view-${project._id}`}
                  text="Copiar ficha"
                  className="w-100"
                  justify="start"
                  funcion={handleCopyButton}
                  data={project._id}
                />
              </Dropdown.Item>

              <Dropdown.Item className="p-1">
                <ButtonShareProperty
                  className="w-100"
                  funcion={() => setShareModal(true)}
                  data={project}
                  text="Honorarios"
                  justify="start"
                  disabled={
                    !(
                      project.status === 'published' &&
                      checkPermission(
                        'Edit properties',
                        userLogged,
                        project.branch_office
                      )
                    )
                  }
                />
              </Dropdown.Item>

              <Dropdown.Item className="p-1">
                <ButtonFinish
                  data={project}
                  funcion={() => setFinishModal(true)}
                  key={`finish-${project._id}`}
                  text="Finalizar"
                  justify="start"
                  disabled={
                    !(
                      (project.status === 'published' ||
                        project.status === 'paused') &&
                      checkPermission(
                        'Edit properties',
                        userLogged,
                        project.branch_office
                      )
                    )
                  }
                  className="w-100"
                />
              </Dropdown.Item>

              {project.status === 'published' &&
                checkPermission(
                  'Edit properties',
                  userLogged,
                  project.branch_office
                ) && (
                  <Dropdown.Item className="p-1">
                    <ButtonPause
                      data={project}
                      funcion={() => setPauseModal(true)}
                      key={`pause-${project._id}`}
                      text="Pausar"
                      className="w-100"
                      justify="start"
                    />
                  </Dropdown.Item>
                )}

              {project.status === 'paused' &&
                checkPermission(
                  'Edit properties',
                  userLogged,
                  project.branch_office
                ) && (
                  <Dropdown.Item className="p-1">
                    <ButtonActive
                      data={project}
                      funcion={() => setFinishModal(true)}
                      key={`active-${project._id}`}
                      text="Activar"
                      className="w-100"
                      justify="start"
                    />
                  </Dropdown.Item>
                )}

              {project.status === 'pending' &&
                checkPermission(
                  'Edit properties',
                  userLogged,
                  project.branch_office
                ) && (
                  <Dropdown.Item className="p-1">
                    <ButtonActive
                      data={project}
                      funcion={() => setFinishModal(true)}
                      key={`active-${project._id}`}
                      disabled={true}
                      text="Activar"
                      className="w-100"
                      justify="start"
                    />
                  </Dropdown.Item>
                )}

              <Dropdown.Item className="p-1">
                <ButtonDelete
                  className="w-100"
                  data={project}
                  funcion={() => setDeleteModal(true)}
                  key={`delete-${project._id}`}
                  text="Eliminar"
                  justify="start"
                  disabled={
                    !(
                      project.status !== 'finished' &&
                      checkPermission(
                        'Delete properties',
                        userLogged,
                        project.branch_office
                      )
                    )
                  }
                />
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        )}
      </span>

      {!onlyView && (
        <>
          {deleteModal && (
            <DeleteModal
              setShow={setDeleteModal}
              project={project}
              handleStatus={handleStatus}
            />
          )}

          {pauseModal && (
            <PauseModal
              setShow={setPauseModal}
              project={project}
              handleStatus={handleStatus}
            />
          )}

          {finishModal && (
            <FinishModal
              setShow={setFinishModal}
              project={project}
              handleStatus={handleStatus}
            />
          )}

          {activeModal && (
            <ActiveModal
              setShow={setActiveModal}
              project={project}
              handleStatus={handleStatus}
            />
          )}

          {shareModal && (
            <ShareModal
              setShow={setShareModal}
              project={project}
              setCheckChanges={setCheckChanges}
            />
          )}
          {sendModal && (
            <SendModal
              setShow={setSendModal}
              property={project}
              setCheckChanges={setCheckChanges}
              type="project"
            />
          )}
        </>
      )}
    </>
  );
};

ProjectActions.propTypes = {
  project: PropTypes.object.isRequired,
  userLogged: PropTypes.object.isRequired,
  setCheckChanges: PropTypes.func.isRequired,
  onlyView: PropTypes.bool
};
